var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-md-4 text-left"},[_c('span',[_vm._v(_vm._s(_vm.label)+" "),(_vm.optional)?_c('span',{staticClass:"small text-muted"},[_vm._v("(optional)")]):_vm._e()])]),_c('div',{staticClass:"col-md-8"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }